import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../http-common";


export interface studentDataSlice {
  data: {} | null;
  isDataFetched: boolean;
  loading: boolean;
  error: string | null;
}

const initialState: studentDataSlice = {
  data: {},
  isDataFetched: false,
  loading: false,
  error: "",
};

export const getStudentTestScores: any = createAsyncThunk("studentTestScores", async () => {
  try {
    const res = await axiosInstance.get("/api/testscores/all");
    return res.data.response.data;
  } catch (err: any) {
    if (err.response.data.errorMessage) {
      console.log(err.response.data.errorMessage);
      // toast.error(err.response.data.errorMessage);
      throw new Error(err.response.data.errorMessage);
    }
    if (err.response.data.errMsg) {
      console.log(err.response.data.errMsg);
      // toast.error(err.response.data.errMsg);
      throw new Error(err.response.data.errMsg);
    } else {
      console.log(err);
      throw new Error(err);
    }
  }
});

export const studentTestScoresSlice = createSlice({
  name: "studentTestScores",
  initialState,
  reducers: {
    remove: (state, action) => {
      state.data = {};
      state.isDataFetched = false;
      state.loading = false;
      state.error = "";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getStudentTestScores.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStudentTestScores.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = null;
        state.isDataFetched = true;
        state.data = action.payload;
      })
      .addCase(getStudentTestScores.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.isDataFetched = false;
        state.error = action.payload;
        state.data = {};
      });
  },
});

export const { remove } = studentTestScoresSlice.actions;
export default studentTestScoresSlice.reducer;
